import { RefObject } from "react";
import { ProgramPhase } from "@core/features/program";
import { ProgramPhasesTimeline } from "./ProgramPhasesTimeline";

export type Props = {
  timelineRef: RefObject<HTMLDivElement>;
  phases: ProgramPhase[];
  selectedPhase: ProgramPhase | undefined;
  setSelectedPhase: (phase: ProgramPhase) => void;
};

export function ProgramPhasesTimelineContainer({
  timelineRef,
  phases,
  selectedPhase,
  setSelectedPhase,
}: Props) {
  // Don't render timeline until we have phases and a selected phase
  if (phases.length === 0 || !selectedPhase) return null;

  return (
    <ProgramPhasesTimeline
      timelineRef={timelineRef}
      selectedPhase={selectedPhase}
      phases={phases}
      setSelectedPhase={setSelectedPhase}
    />
  );
}

export default ProgramPhasesTimelineContainer;

